import Button from 'components/Button'
import UploadResultIcon from 'components/icons/SubmitCloseIcon.js'
import React from 'react'
import { ButtonDiv, ResultDiv, ResultIconDiv, UploadMsgFlex } from './Style'

const AddConfirm = ({ onClose, file, finalUpload }) => {
  return (
    <UploadMsgFlex column center centerVertically>
      <ResultIconDiv>
        <UploadResultIcon />
      </ResultIconDiv>
      <ResultDiv>
        {finalUpload === 2
          ? 'Students successfully listed and rejected all the other students'
          : 'Status uploaded successfully'}
      </ResultDiv>

      <ButtonDiv>
        <Button.Secondary
          text="Close"
          width="80px"
          height="36px"
          onClick={onClose}
        />
      </ButtonDiv>
    </UploadMsgFlex>
  )
}

export default AddConfirm
